import type { Action } from '@artosera/shared/permissions';
import { usePeut } from '../../auth/usePeut.js';
import type { VueDAigle } from '../../types.js';

/**
 * Ce que la vue affichée permet. La vue `associe` ne porte aucune action,
 * même pour un rôle opérationnel qui la regarde en « Voir comme un
 * associé » : l'aperçu montre ce que verrait un associé, boutons compris.
 * La matrice (`usePeut`) reste la seule source des droits.
 */
export function useDroitsVue(vue: VueDAigle): {
  admin: boolean;
  peut: (action: Action) => boolean;
} {
  const peutAction = usePeut();
  const admin = vue.vue === 'admin';
  return { admin, peut: (action) => admin && peutAction(action) };
}
